<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button type="dashed" v-if="config.hasAlert" @click="tableOption">{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:1500 }"
      :alert="options.alert"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
      :rowSelection="options.rowSelection">
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical"/>
        <a-dropdown>
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item><a @click="handleDetail(record)">详情</a></a-menu-item>
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal title="编辑" style="top: 20px;" :width="560" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="所属装货点" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select disabled
            placeholder="请选择所属装货点"
            v-decorator="['factoryLoadId',
            { initialValue: mdl.factoryLoadId, rules: [{ required: true, message: '请选择所属装货点'}]}]">
            <a-select-option v-for="(item, index) in factoryLoadSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="装卸料口ID" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number 
            :min="1"
            placeholder="请输入装卸料口ID" 
            v-decorator="['materialLoadId',
            { initialValue: mdl.materialLoadId, rules: [{ required: true, message: '请输入装卸料口ID'}]}]" style="width: 100%"/>
        </a-form-item>

        <a-form-item label="料口编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="请输入料口编号"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请输入料口编号'}]}]" />
        </a-form-item>

        <a-form-item label="终端编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="请输入终端编号"
            v-decorator="['terminalCode',
            { initialValue: mdl.terminalCode, rules: [{ required: true, message: '请输入终端编号'}]}]" />
        </a-form-item>

        <a-form-item label="控制器IP" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.ctrlIp" placeholder="请输入控制器IP" />
        </a-form-item>

        <a-form-item label="控制器服务端端口号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.serverPort" placeholder="请输入控制器服务端端口号" />
        </a-form-item>

        <a-form-item label="门禁读卡器IP" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.doorCardIp" placeholder="请输入门禁读卡器IP" />
        </a-form-item>

        <a-form-item label="门禁读卡器端口号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.doorCardPort" placeholder="请输入门禁读卡器端口号" />
        </a-form-item>

        <a-form-item label="大屏幕地址" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.screenAddress" placeholder="请输入大屏幕地址" />
        </a-form-item>

        <a-form-item label="计数器通讯地址" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.counterAddress" placeholder="请输入计数器通讯地址" />
        </a-form-item>

        <a-form-item label="计数器设备地址ID" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.counterDeviceAddress" placeholder="请输入计数器设备地址ID" />
        </a-form-item>

        <a-form-item label="计数器波特率" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.counterBaudRate" placeholder="请输入计数器波特率" />
        </a-form-item>

        <a-form-item label="计数器数据位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.counterDataBit" placeholder="请输入计数器数据位" />
        </a-form-item>

        <a-form-item label="计数器校验位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.counterParityBit" placeholder="请输入计数器校验位" />
        </a-form-item>

        <a-form-item label="计数器停止位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.counterStopBit" placeholder="请输入计数器停止位" />
        </a-form-item>

        <a-form-item label="喷码机通讯地址" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.printerAddress" placeholder="请输入喷码机通讯地址" />
        </a-form-item>

        <a-form-item label="喷码机设备地址ID" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.printerDeviceAddress" placeholder="请输入喷码机设备地址ID" />
        </a-form-item>

        <a-form-item label="喷码机波特率" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.printerBaudRate" placeholder="请输入喷码机波特率" />
        </a-form-item>

        <a-form-item label="喷码机数据位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.printerDataBit" placeholder="请输入喷码机数据位" />
        </a-form-item>

        <a-form-item label="喷码机校验位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.printerParityBit" placeholder="请输入喷码机校验位" />
        </a-form-item>

        <a-form-item label="喷码机停止位" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.printerStopBit" placeholder="请输入喷码机停止位" />
        </a-form-item>

        <a-form-item label="熟料皮带秤通讯地址" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.beltScaleAddress" placeholder="请输入熟料皮带秤通讯地址" />
        </a-form-item>

        <a-form-item label="货物包装类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="请选择货物包装类型"
            v-decorator="['materielType',
            { initialValue: mdl.materielType, rules: [{ required: true, message: '请选择货物包装类型'}]}]">
            <a-select-option v-for="(item, index) in materielTypeSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="DCS服务名" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.dcsServerName" placeholder="请输入DCS服务名" />
        </a-form-item>

        <a-form-item label="DCS标签" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.dcsTag" placeholder="请输入DCS标签" />
        </a-form-item>

        <a-form-item label="启用/禁用" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="请选择启用/禁用"
            v-decorator="['used',
            { initialValue: mdl.used, rules: [{ required: true, message: '请选择启用/禁用'}]}]">
            <a-select-option v-for="(item, index) in usedSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="运输工具类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="请选择运输工具类型"
            v-decorator="['transportType',
            { initialValue: mdl.transportType, rules: [{ required: true, message: '请选择运输工具类型'}]}]">
            <a-select-option v-for="(item, index) in transportTypeSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { factoryLoadList, factoryLoadPortPage, factoryLoadPortUpdate, factoryLoadPortSave, factoryLoadPortDelete } from '@/api/basic'
import storage from "@/utils/storage"
import queryMixin from '@/mixins/queryMixin'
import { formatDate } from '@/utils/date'
export default {
  name: 'FactoryLoadPort',
  mixins: [queryMixin],
  components: {
    STable
  },
  data () {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          // width: '150px',
          fixed:"left"
        },
        {
          title: '料口编号',
          dataIndex: 'code',
          width: '120px',
        },
        {
          title: '终端编号',
          dataIndex: 'terminalCode',
          width: '120px',
        },
        {
          title: '所属装卸货点',
          dataIndex: 'factoryLoadName',
          width: '150px',
        },
        {
          title: '物料包装类型',
          dataIndex: 'materielTypeName',
          width: '150px',
        },
        {
          title: '启用状态',
          dataIndex: 'usedName',
          width: '120px',
        },
        {
          title: '运输工具类型',
          dataIndex: 'transportTypeName',
          width: '150px',
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        }
      ],

      // 所属装卸货点下拉
      factoryLoadSelect: null,
      // 货物包装类型下拉
      materielTypeSelect: null,
      // 禁用/启用下拉
      usedSelect: null,
      // 运输工具类型下拉
      transportTypeSelect: null,

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        let cache = storage.fetch("cache-FactoryLoadPort");
        if (cache){
            let obj = JSON.parse(cache)
            this.queryParam['factoryLoadId'] = obj.id
        }
        return factoryLoadPortPage(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created () {
    this.tableOption()
    this.loadSelect()

    // 初始化查询条件
    this.queryParam =  this.queryParam || null
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    loadSelect () { // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = factoryLoadList().then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.factoryLoadSelect = res
      })
      this.materielTypeSelect = this.$store.getters.codeList.basic_factory_load_port_materiel_type
      this.usedSelect = this.$store.getters.codeList.sys_used
      this.transportTypeSelect = this.$store.getters.codeList.basic_factory_load_port_transport_type
    },
    filterOption (input, option) { // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit (record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd () {
      this.mdl = {}
      this.mdl.factoryLoadId = this.queryParam.factoryLoadId
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        Object.assign(this.mdl, values)
        if (!err) { 
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            factoryLoadPortUpdate(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.$refs.table.refresh()
                this.visible = false
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
              this.confirmLoading = false
            })
          } else {
            values.factoryLoadId = this.queryParam.factoryLoadId
            factoryLoadPortSave(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.$refs.table.refresh()
                this.visible = false
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    handleDel (record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk () {
          return factoryLoadPortDelete({ 'ids': record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
            })
        },
        onCancel () {
        }
      })
    },
    handleDetail (record) {
      storage.save("cache-FactoryLoadPortDetail", JSON.stringify(record));
      this.$router.push({name: "FactoryLoadPortDetail"})
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>
